import React from "react"
import PropTypes from "prop-types"
import "./index.less"
import { Popover } from "antd"
import { validate } from "../../../utils/functions"
import { loadTexts, sanitize } from "../../../utils/i18n"

export function PopoverImpact(props) {
  const intlPopoverImpact = loadTexts("reports_general_view").reportAmbassador
    .engagementMeasurement.widgetResultByDimensionEngagement
  const renderContent = () => {
    return (
      <div className="PopoverImpact-content">
        {sanitize(intlPopoverImpact.popoverImpactContent)}
      </div>
    )
  }

  return (
    <Popover
      wid
      overlayClassName="PopoverImpact"
      content={renderContent()}
      title={intlPopoverImpact.popoverImpactTitle}>
      {validate.exist(props.container) ? (
        props.container
      ) : (
        <span className="PopoverImpact-text">
          {intlPopoverImpact.popoverImpactTitle}
        </span>
      )}
    </Popover>
  )
}

PopoverImpact.propTypes = {
  isGlobalBenchmark: PropTypes.bool,
  container: PropTypes.object,
}

export default PopoverImpact
